import certificateReducer from './certificateReducer';
export default certificateReducer;